import { tKey } from 'ember-intl';
import type { TagType } from 'lumen/models/custom-tag-definition';

export const FREE_TEXT_MAX_LENGTH = 120;
export const MAX_CUSTOM_TAG_DEFINITIONS = 10;
export const MAX_CUSTOM_TAG_DEFINITION_OPTIONS = 15;
export const MAX_NAME_LENGTH = 30;

export const TAG_TYPES: TagType[] = ['list', 'text', 'user'];

export const TAG_TYPE_TRANSLATIONS: Record<TagType, ReturnType<typeof tKey>> = {
  list: tKey('settings.property_tags.custom_tags.form.tag_type.list'),
  text: tKey('settings.property_tags.custom_tags.form.tag_type.text'),
  user: tKey('settings.property_tags.custom_tags.form.tag_type.users'),
};
